import React, { useEffect } from 'react';
import styled from "@emotion/styled";
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import dayjs from 'dayjs';
import { getWebCalculationsSupplementary, i18n, mq, setCustomer, setFlowType, setProgressBarPercentage, useAppDispatch } from 'src/common';
import { ArrowLeftIcon, BestPriceCard, Button, Card, CustomerForm, HtmlText, HtmlTextLink, Loader, Text } from 'src/components';
import { colors } from 'src/theme';
import { AppRoutes } from '../_router/app.routes';

const ButtonWrapper = styled.div({
  width: '100%',
  textAlign: 'center',
  marginBottom: 24
})

const TitleStyle = styled(Text)({
  marginBottom: 16
})

const BestPriceCardStyle = styled(BestPriceCard)({
  marginBottom: 8,
})

const CardStyle = styled(Card)(
  mq({
    padding: ['16px', '16px', "24px", "24px", "40px"],
    marginBottom: 16
  })
)

const htmlTextLinks: Array<HtmlTextLink> = [
  { value: 'form', link: 'https://kompare.hr/obrazac-za-prituzbe/', translation: i18n.t('pages.customerPage.htmlTextLinkTranslations.form') },
  { value: 'mail', link: 'mailto:szop@kompare.hr', translation: 'szop@kompare.hr' },
  { value: 'here', link: 'https://kompare.hr/informacije-o-koristenju-osobnih-podataka/', translation: i18n.t('pages.customerPage.htmlTextLinkTranslations.here') },
];

const CustomerWithDatePage = () => {
  const { birthDate } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setProgressBarPercentage(20));
    dispatch(setFlowType('web'));
  }, []);

  useEffect(() => {
    dispatch(setCustomer({ birthDate, age: dayjs().diff(dayjs(birthDate), 'year') }));
  }, [birthDate]);

  const { data, loading } = useQuery(getWebCalculationsSupplementary, {
    variables: { birthDate },
    skip: !birthDate
  });

  // Destrukturiranje podataka
  const { health } = data || {};
  const { webCalculationsSupplementary } = health || {};

  if (loading) return <Loader page />;

  // Pronalaženje proizvoda s najmanjom cijenom na rate
  const offerWithLowestInstallmentPrice = webCalculationsSupplementary?.length > 0 ? webCalculationsSupplementary?.reduce((prevOffer: any, currentOffer: any) => {
    if (!prevOffer) {
      return currentOffer;
    }
    if (currentOffer.price.totalWithInstallments < prevOffer.price.totalWithInstallments) {
      return currentOffer;
    }
    return prevOffer;
  }, null) : undefined;

  return (
    <>
      <BestPriceCardStyle price={offerWithLowestInstallmentPrice ? (offerWithLowestInstallmentPrice.price.totalWithInstallments / 12) : undefined} />
      <ButtonWrapper>
        <Button
          btnType='textPrimary'
          iconPosition='left'
          onClick={() => { navigate(AppRoutes.CUSTOMER.fullPath) }}
          text={i18n.t('pages.customerPage.changeDateOfBirth')}
          style={{ textAlign: 'center' }}
        >
          <ArrowLeftIcon color={colors.primary} />
        </Button>
      </ButtonWrapper>
      <CardStyle title={<TitleStyle type="large" bold>{i18n.t('pages.customerPage.titleWithDateOfBirth')}</TitleStyle>}>
        <CustomerForm customer={{ birthDate }} formItems={['email', 'phoneNumber']} />
      </CardStyle>
      <HtmlText i18nKey="pages.customerPage.gdprConsentWithParams" links={htmlTextLinks} />
    </>
  );
}

export default CustomerWithDatePage;
